export default __webpack_public_path__ + "static/media/11.31351161.jpg";